class PlayerVideoModule {
    constructor() {
        this.initialize();
    }

    initialize() {
        this.bindUI();
        this.bindEvents();
    }

    bindUI() {
        this.ui = {};

        this.ui.thumbnail = document.querySelectorAll('.js-player');
        this.ui.playerVideo = document.querySelectorAll('.js-video iframe');
    }

    bindEvents() {
        [].forEach.call(this.ui.thumbnail, (item, index) => {
            item.addEventListener('click', this.playVideo.bind(this, index));
        });
    }

    playVideo(index) {
        this.ui.thumbnail[index].classList.add('is-active');
    }
}

export default PlayerVideoModule;
